import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=52c262ec&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c262ec')) {
      api.createRecord('52c262ec', component.options)
    } else {
      api.reload('52c262ec', component.options)
    }
    module.hot.accept("./AccessDenied.vue?vue&type=template&id=52c262ec&", function () {
      api.rerender('52c262ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AccessDenied.vue"
export default component.exports